'use client';

import React, { useState } from 'react';
import HeroSection from './HeroSection';
import ChallengeSection from './ChallengeSection';
import SolutionSection from './SolutionSection';
import MethodologySection from './MethodologySection';
import ServicesSection from './ServicesSection';
import CaseStudiesSection from './CaseStudiesSection';
import CTASection from './CTASection';
import BookingModal from './BookingModal';

const ServicesInteractive = () => {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);

  const handleBookCall = () => {
    setIsBookingModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsBookingModalOpen(false);
  };

  return (
    <>
      <HeroSection onBookCall={handleBookCall} />
      <ChallengeSection />
      <SolutionSection />
      <MethodologySection />
      <ServicesSection />
      <CaseStudiesSection />
      <CTASection onBookCall={handleBookCall} />
      <BookingModal isOpen={isBookingModalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default ServicesInteractive;